<!-- 収集運搬業者詳細 -->
<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-card
      flat
    >
      <v-toolbar flat>
        <v-toolbar-title>収集運搬業者詳細</v-toolbar-title>
      </v-toolbar>
      <v-card
        class="mx-auto"
        max-width="600"
        outlined
      >
        <v-card-text>
          <v-list-item two-line>
            <v-list-item-content>
              <v-row align="center">
                <v-col cols="12" md="6">
                  <v-list-item-title class="text-h5">
                    {{ transport.name }}
                  </v-list-item-title>
                </v-col>
                <v-col cols="12" md="6" class="d-flex justify-end">
                  <v-checkbox
                    v-model="transport.invisible"
                    :disabled="!transport.use_deleted"
                    label="非表示にする"
                    hide-details="auto"
                    @change="updateInvisible"
                  />
                </v-col>
              </v-row>
              <v-list-item-subtitle> {{ transport.subscriber_number }} </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-map-marker</v-icon>
            </v-list-item-icon>
            <v-list-item-subtitle>
              <div v-if="transport.zip_code">〒{{ transport.zip_code }}</div>
              <div>{{ transport.address }}</div>
            </v-list-item-subtitle>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-phone</v-icon>
            </v-list-item-icon>
            <v-list-item-subtitle> {{ transport.phone_number }} </v-list-item-subtitle>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-fax</v-icon>
            </v-list-item-icon>
            <v-list-item-subtitle> {{ transport.fax_number }} </v-list-item-subtitle>
          </v-list-item>
        </v-card-text>
      </v-card>

      <v-card-text>
        <v-data-table
          :headers="tableHeaders"
          :items="transport.locations"
          disable-sort
          hide-default-footer
        >
          <template v-slot:[`item.address`]="{ item }">
            <span :title="item.address">{{ item.address | truncate(25) }}</span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <confirm ref="confirm" />
  </v-container>
</template>
<script>
import { mapActions} from 'vuex'
import Confirm from "@/components/Confirm.vue";
export default {
  name: 'DriverMasterTransportShow',
  components: {Confirm},
  filters: {
  },
  mixins: [
  ],
  data () {
    return {
      breadcrumbs: [
        { text: '収集運搬業者一覧', disabled: false, to: '/driver/masters/transports', exact: true },
        { text: '収集運搬業者詳細', disabled: true, to: '' },
      ],
      tableHeaders: [
        { value: 'location_code', text: '事業場コード' },
        { value: 'location_name', text: '事業場名称' },
        { value: 'location_type_name', text: '事業者区分' },
        { value: 'zip_code', text: '郵便番号' },
        { value: 'address', text: '所在地' },
        { value: 'phone_number', text: '電話番号' },
        { text: '', value: 'editable', align: 'end' },
      ],
      transport: {},
      initialInvisible: false,
    }
  },
  created() {
    this.fetchTransport({ id: this.$route.params.id }).then((content) => {
      this.transport = content
      this.initialInvisible = content.invisible;
    })
  },
  methods: {
     ...mapActions('DriverMasterTransport', {
      fetchTransport: 'show',
      deleteTransport: 'destroy',
      updateTransport: 'update',
    }),
    updateInvisible() {

       if (!this.initialInvisible && this.transport.invisible) {

         let modalOption = { title: '更新', message: '関連する運搬ルートを含め非表示で更新します。よろしいですか？', options: { titleColor: 'blue' } }
         this.$refs.confirm.open(modalOption).then((confirm) => {
           this.$refs.confirm.close()
           if (confirm) {
             const params = {
               invisible: this.transport.invisible
             }
             this.updateTransport({ id: this.transport.id, params })
           } else {
               this.transport.invisible = false;
           }
         })

       } else {
         const params = {
           invisible: this.transport.invisible
         }
         this.updateTransport({ id: this.transport.id, params })
       }

    }
  }
}
</script>

<style scoped>

</style>
